import BaseFooter from '../BaseFooter/BaseFooter.vue';
import FooterLinks from '../FooterLinks/FooterLinks.vue';
import FooterMarketing from '../FooterMarketing/FooterMarketing.vue';

export default {
  components: {
    BaseFooter,
    FooterLinks,
    FooterMarketing,
  },
};
